/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Finding state transition result
 * @export
 * @interface FindingStateTransitionResponse
 */
export interface FindingStateTransitionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FindingStateTransitionResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindingStateTransitionResponse
     */
    instanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingStateTransitionResponse
     */
    previousState?: FindingStateTransitionResponsePreviousStateEnum;
    /**
     * 
     * @type {string}
     * @memberof FindingStateTransitionResponse
     */
    newState?: FindingStateTransitionResponseNewStateEnum;
    /**
     * 
     * @type {string}
     * @memberof FindingStateTransitionResponse
     */
    exceptionId?: string;
}


/**
 * @export
 */
export const FindingStateTransitionResponsePreviousStateEnum = {
    Open: 'OPEN',
    Remediated: 'REMEDIATED',
    FalsePositive: 'FALSE_POSITIVE',
    RiskAccepted: 'RISK_ACCEPTED',
    Exception: 'EXCEPTION',
    Superseded: 'SUPERSEDED',
    RemediationPending: 'REMEDIATION_PENDING'
} as const;
export type FindingStateTransitionResponsePreviousStateEnum = typeof FindingStateTransitionResponsePreviousStateEnum[keyof typeof FindingStateTransitionResponsePreviousStateEnum];

/**
 * @export
 */
export const FindingStateTransitionResponseNewStateEnum = {
    Open: 'OPEN',
    Remediated: 'REMEDIATED',
    FalsePositive: 'FALSE_POSITIVE',
    RiskAccepted: 'RISK_ACCEPTED',
    Exception: 'EXCEPTION',
    Superseded: 'SUPERSEDED',
    RemediationPending: 'REMEDIATION_PENDING'
} as const;
export type FindingStateTransitionResponseNewStateEnum = typeof FindingStateTransitionResponseNewStateEnum[keyof typeof FindingStateTransitionResponseNewStateEnum];


/**
 * Check if a given object implements the FindingStateTransitionResponse interface.
 */
export function instanceOfFindingStateTransitionResponse(value: object): value is FindingStateTransitionResponse {
    return true;
}

export function FindingStateTransitionResponseFromJSON(json: any): FindingStateTransitionResponse {
    return FindingStateTransitionResponseFromJSONTyped(json, false);
}

export function FindingStateTransitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingStateTransitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'previousState': json['previousState'] == null ? undefined : json['previousState'],
        'newState': json['newState'] == null ? undefined : json['newState'],
        'exceptionId': json['exceptionId'] == null ? undefined : json['exceptionId'],
    };
}

export function FindingStateTransitionResponseToJSON(json: any): FindingStateTransitionResponse {
    return FindingStateTransitionResponseToJSONTyped(json, false);
}

export function FindingStateTransitionResponseToJSONTyped(value?: FindingStateTransitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'instanceId': value['instanceId'],
        'previousState': value['previousState'],
        'newState': value['newState'],
        'exceptionId': value['exceptionId'],
    };
}

